<div *ngIf="isOpen" 
         class="fixed inset-0 z-50 flex items-center justify-center p-4"
         (click)="onBackdropClick($event)">
      
      <!-- Backdrop -->
      <div class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"></div>
      
      <!-- Modal Container -->
      <div class="relative bg-white rounded-xl shadow-2xl max-h-[95vh] overflow-hidden transform transition-all"
           [ngClass]="modalSizeClasses"
           (click)="$event.stopPropagation()"
            tabindex="0">
        
        <!-- Header -->
        <div *ngIf="config?.title || config?.closable" 
            [ngClass]="{'border-b': !config?.hideborder}"
             class="flex items-center justify-between p-6  bg-white">
             <!-- <div class="flex gap-4"> -->              
                <h3 *ngIf="config?.title" class="text-xl font-semibold text-gray-900">
                    {{ config?.title }}
                </h3>
             <!-- </div> -->
          
          <button *ngIf="config?.closable" 
                  (click)="closeModal()"
                  class="p-2 hover:bg-gray-100 rounded-lg transition-colors">
            
            <img src="icons/close-circle.svg" alt="Close Modal" class="w-6 h-6">
          </button>
        </div>
        
        <!-- Dynamic Content Container -->
        <div class="bg-white" [ngClass]="{'overflow-y-auto max-h-[calc(95vh-120px)]': !config?.data?.noScroll}">
          <!-- Static Content (ng-content) -->
          <!-- <ng-content ></ng-content> -->
          
          <!-- Confirmation Dialog Content -->
          <div *ngIf="isConfirmationDialog" class="p-4">
            <!-- Icon and Message -->
            <div class="flex items-start gap-4 mb-6" *ngIf="config?.data?.message !== ''">
              <!-- <div class="flex-shrink-0 p-3 rounded-full" [ngClass]="confirmationTypeClasses">
                <img [src]="confirmationIconPath" alt="Warning" class="w-6 h-6">
              </div> -->
              
              <div class="flex-1">
                <p class="text-gray-600">
                  {{ config?.data?.message }}
                </p>
              </div>
            </div>
             <div *ngIf="config?.data?.requireNote" class="mb-4">
    <label class="block text-sm font-medium text-gray-700 mb-1">
      {{ config?.data?.noteLabel || ('NOTES' | translate) }} <span class="text-red-500">*</span>
    </label>
    <textarea
      [(ngModel)]="note"
      [placeholder]="config?.data?.notePlaceholder || ''"
      class="w-full p-2 border border-gray-300 rounded-lg"
      rows="4"
      required
    ></textarea>
    <div *ngIf="noteError" class="text-red-500 text-sm mt-1">
      {{ 'SET_OFFER_DETAILS.ERRORS.NOTE_IS_REQUIRED' | translate }}
    </div>
  </div>

  <!-- Optional Attachment Field -->
  <div *ngIf="config?.data?.requireAttachment" class="mb-4">
    <label class="block text-sm font-medium text-gray-500 mb-2">
      {{ 'COMMON.ATTACHMENT' | translate }} ({{ 'COMMON.OPTIONAL' | translate }})
    </label>
    <!-- Upload Area with Dashed Border -->
    <label *ngIf="!attachmentName" class="cursor-pointer flex items-center justify-center gap-2 py-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-gray-400 hover:bg-gray-50 transition-colors">
      <img src="icons/document-upload.svg" alt="Upload" class="w-5 h-5 opacity-60">
      <span class="text-sm text-gray-600">{{ 'COMMON.UPLOAD' | translate }}</span>
      <input 
        type="file" 
        class="hidden" 
        (change)="onAttachmentSelected($event)"
        accept=".pdf,.doc,.docx,.png,.jpg,.jpeg">
    </label>
    <div *ngIf="attachmentTooLarge" class="text-red-500 text-sm mt-1">
      {{ 'COMMON.ATTACHMENT_TOO_LARGE' | translate }}
    </div>
    <!-- Selected File Display (NHP Proposal File style) -->
    <div *ngIf="attachmentName" class="flex items-center justify-between rounded-md py-2 px-4 bg-[#F5F6FA] border border-gray-200">
      <div class="flex-1 text-gray-700 text-base">
        {{ 'COMMON.ATTACHMENT' | translate }}
      </div>
      <div class="flex items-center gap-2">
        <img [src]="getFileIcon(attachmentName)" alt="file icon" class="w-5 h-5" />
        <span class="underline cursor-pointer text-gray-700 text-sm truncate max-w-[180px]"
          [title]="attachmentName"
          (click)="downloadLocalAttachment()">
          {{ attachmentName }}
        </span>
        <button 
          type="button" 
          (click)="removeAttachment()" 
          class="text-gray-400 hover:text-red-600 text-md font-bold px-1">×</button>
      </div>
    </div>
   
  </div>
   <div *ngIf="config?.data?.infoText" class="info-text mb-2 flex items-start gap-1">
      <img src="icons/info-circle.svg" class="w-4 h-4" />
      <p class="text-[10px] text-[#3B3874]">
        {{ config?.data?.infoText }}
      </p>
    </div>

            <!-- Action Buttons -->
            <div class="flex items-center justify-end gap-3 border-t border-gray-100 pt-4">
              <button
                (click)="onConfirmationCancel()"
                class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                {{ config?.data?.cancelText || 'Cancel' }}
              </button>

              <button
                (click)="onConfirmationConfirm()"
                class="px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors"
                [ngClass]="confirmationButtonClasses">
                {{ config?.data?.confirmText || 'Confirm' }}
              </button>
            </div>
          </div>
          
          <!-- Plain Body Content (when no component provided) -->
          <div *ngIf="!isConfirmationDialog && !config?.component && !config?.link && config?.data?.body" class="p-6">
            <p class="text-gray-600 whitespace-pre-line">{{ config?.data?.body }}</p>
          </div>
          
          <!-- Dynamic Component Container -->
          <div *ngIf="!isConfirmationDialog && config?.component" #dynamicComponentContainer></div>
          
          <!-- If External Link -->
          <div *ngIf="config?.link">
            <iframe 
            [src]="contractSafeUrl"
            (load)="onIframeLoad()" 
            class="w-full h-[80vh] border-0"></iframe>
          </div>
        </div>
      </div>
    </div>
